<script lang="ts">
    import type InstagramStoryEntity from "@apps/instagram/entities/InstagramStoryEntity";

    import VideoPlayer from "@components/VideoPlayer/VideoPlayer.svelte";

    export let story: InstagramStoryEntity;
    export let videoSoundMuted: boolean;
</script>

<div class="gw-ig-story-modal-video">
    {#if story.videoUrl}
        {#key story.videoUrl}
            <VideoPlayer
                muted={videoSoundMuted}
                autoplay
                sources={[
                    {
                        src: story.videoUrl,
                        mime: "video/mp4",
                    },
                ]}
                showVideoControll={false}
                showUIPanel={false}
                showSpinner={false}
                on:initialized
            />
        {/key}
    {/if}
</div>

<style>
    .gw-ig-story-modal-video {
        display: flex;
        position: relative;
        height: 100%;
    }
    .gw-ig-story-modal-video :global(.gw-ig-story-modal-video__img) {
        display: block;
        width: 100%;
        height: 100%;
    }
    .gw-ig-story-modal-video :global(.gw-ig-story-modal-video__icon) {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 100px;
        height: 100px;
        transform: translateX(-50%) translateY(-50%);
        color: #ccc;
    }

    @keyframes pulse {
        0% {
            box-shadow: 0 0 0 0 var(--gw-ig-modal-tag-shadow-main-color);
        }
        70% {
            box-shadow: 0 0 0 20px
                var(--gw-ig-modal-tag-shadow-transparent-color);
        }
        100% {
            box-shadow: 0 0 0 0 var(--gw-ig-modal-tag-shadow-transparent-color);
        }
    }
</style>
